import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 12h-6","key":"svg-0"}],["path",{"d":"M2 12h6","key":"svg-1"}],["path",{"d":"M8 7l8 5l-8 5l0 -10","key":"svg-2"}],["path",{"d":"M14 7h2v10h2","key":"svg-3"}]]

const IconCircuitDiodeZener = createReactComponent('outline', 'circuit-diode-zener', 'CircuitDiodeZener', __iconNode);

export default IconCircuitDiodeZener;